export default "__VITE_PUBLIC_ASSET__d107a434__"